import Filter from './Filter.model';

let Backbone = window.Backbone;

export default Backbone.Collection.extend({
  model: Filter,
  initialize: function() {
    window.sfscpaVent.on('add-filter', (filter) => {
      this.add(filter)
    });

    window.sfscpaVent.on('delete-filter', (filter) => {
      this.remove(filter)
    });
  },
});


// WEBPACK FOOTER //
// ./assets/src/javascripts/userContent/filters/SelectedFilters.collection.js